import { useEffect } from 'react';

const TABLEAU_SCRIPT_ID = 'tableau-embedding-api';
const TABLEAU_SCRIPT_SRC =
  'https://tableau.naic.org/javascripts/api/tableau.embedding.3.latest.min.js';

/**
 * Appends the Tableau embedding API module script to document.head exactly once,
 * but only when a non-empty (trimmed) dashboard URL is provided. Idempotent: if a
 * script with id `tableau-embedding-api` already exists, it is left untouched.
 */
export default function useTableauEmbedScript(dashboardUrl?: string): void {
  useEffect(() => {
    if (!dashboardUrl?.trim()) return;
    if (document.getElementById(TABLEAU_SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = TABLEAU_SCRIPT_ID;
    script.type = 'module';
    script.src = TABLEAU_SCRIPT_SRC;
    document.head.appendChild(script);
  }, [dashboardUrl]);
}
